<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="ID Grup" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="IDGroup"
                    label="ID Grup"
                    :error-messages="errors"
                    placeholder="ID Grup"
                    v-model="form.IDGroup"
                    hide-details="auto"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </Validate>
                <Validate name="Nama" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Name"
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama"
                    v-model="form.Name"
                    hide-details="auto"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </Validate>
                <Validate name="Deskripsi" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Description"
                    label="Deskripsi"
                    :error-messages="errors"
                    placeholder="Deskripsi"
                    v-model="form.Description"
                    hide-details="auto"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </Validate>
                <Validate name="Induk Grup" rules #default="{ errors }">
                  <v-autocomplete
                    class="mb-3"
                    :items="list.grup.data"
                    item-text="Name"
                    item-value="ID"
                    name="Induk Grup"
                    label="Induk Grup"
                    :error-messages="errors"
                    placeholder="Induk Grup"
                    hide-details="auto"
                    dense
                    v-model="form.IDParentGroup"
                    :return-object="false"
                    outlined
                  ></v-autocomplete>
                </Validate>
                <Validate name="Tipe" rules="required" #default="{ errors }">
                  <v-select
                    class="mb-3"
                    :items="list.tipeGrup.data"
                    name="Tipe"
                    label="Tipe"
                    :error-messages="errors"
                    placeholder="Tipe"
                    v-model="form.Type"
                    :return-object="false"
                    hide-details="auto"
                    outlined
                    dense
                    required
                  ></v-select>
                </Validate>
                <Validate name="Status">
                  <v-switch v-model="form.Status" inset label="Status"></v-switch>
                </Validate>
                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Name: "",
      Description: "",
      IDParentGroup: "",
      IDGroup: "",
      Status: false,
      Type: ""
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isGrupLoading"])
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      this.form.Status = this.form.Status ? 1 : 0;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/group", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/pengaturan/grup");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Grup" : "Grup Baru";
    },

    ...mapActions("list", ["refreshGrup"])
  },
  async mounted() {
    this.refreshGrup();
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/group/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
          this.form.Status = res.data.Data.Status > 0 ? true : false;
          this.list.grup.data = this.list.grup.data.filter(
            g => g.ID != this.form.ID
          );
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>